import { render, staticRenderFns } from "./SfPromotionActivityPop.vue?vue&type=template&id=63a71603"
import script from "./SfPromotionActivityPop.vue?vue&type=script&lang=js"
export * from "./SfPromotionActivityPop.vue?vue&type=script&lang=js"
import style0 from "./SfPromotionActivityPop.vue?vue&type=style&index=0&id=63a71603&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a71603')) {
      api.createRecord('63a71603', component.options)
    } else {
      api.reload('63a71603', component.options)
    }
    module.hot.accept("./SfPromotionActivityPop.vue?vue&type=template&id=63a71603", function () {
      api.rerender('63a71603', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cp/popup/SfPromotionActivityPop.vue"
export default component.exports